import { Button, Table } from '@nrx/ui';

import type { FxFile } from '../lib/client.js';
import { formatDate, formatSize } from '../lib/format.js';

export interface FileTableProps {
  readonly files: readonly FxFile[];
  readonly onDownload: (key: string) => void;
  readonly loading?: boolean;
  /** Folders at this level, listed above the files. */
  readonly folders?: readonly string[];
  readonly onOpenFolder?: (name: string) => void;
}

export function FileTable({
  files,
  onDownload,
  loading = false,
  folders = [],
  onOpenFolder,
}: FileTableProps): React.JSX.Element {
  if (!loading && files.length === 0 && folders.length === 0) {
    return <p className="py-8 text-center text-sm text-gray-500">No files in this folder</p>;
  }

  return (
    <Table.ScrollArea loading={loading} loadingLabel="Loading files…">
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Size</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Modified</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell className="text-right">Actions</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {folders.map((name) => (
            <Table.Row key={`folder:${name}`}>
              <Table.Cell className="font-medium text-gray-900">
                <Button
                  tone="link"
                  aria-label={`Open folder ${name}`}
                  onClick={() => onOpenFolder?.(name)}
                >
                  {name}/
                </Button>
              </Table.Cell>
              <Table.Cell className="text-gray-600">—</Table.Cell>
              <Table.Cell className="text-gray-600">—</Table.Cell>
              <Table.Cell>{null}</Table.Cell>
            </Table.Row>
          ))}
          {files.map((f) => (
            <Table.Row key={f.key}>
              <Table.Cell className="font-medium text-gray-900">{f.name}</Table.Cell>
              <Table.Cell className="text-gray-600">{formatSize(f.size)}</Table.Cell>
              <Table.Cell className="text-gray-600">{formatDate(f.lastModified)}</Table.Cell>
              <Table.Cell className="text-right">
                <Button tone="link" onClick={() => onDownload(f.key)}>
                  Download
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
}
